export const ECHOIMAGES = {
  Auth: {
    Logo: require('../Assets/logo.svg').default,
    LogoWhite: require('../Assets/white-logo.svg').default,
    StrAlignLogo: require('../Assets/StrAlign-logo.svg').default,
    AuthLogo: require('../Assets/Auth-Logo.svg').default,
    LoginImg: require('../Assets/authPages/login.svg').default,
    signupSlide1: require('../Assets/authPages/signupSlide1.svg').default,
    signupSlide2: require('../Assets/authPages/signupSlide2.svg').default,
    signupSlide3: require('../Assets/authPages/signupSlide3.svg').default,
    forgotPassword: require('../Assets/authPages/forgotPassword.svg').default,
    Background: require('../Assets/authPages/lightBlueBG.svg').default,
    PasswordChanged: require('../Assets/authPages/passwordChanged.svg').default,
  },
  HomeIcons: {
    pendingAction: require('../Assets/home/pendingAction.svg').default,
    pendingComparison: require('../Assets/home/pendingComparison.svg').default,
    pendingRating: require('../Assets/home/pendingRating.svg').default,
    downArrow: require('../Assets/home/downArrow.svg').default,
    upArrow: require('../Assets/home/upArrow.svg').default,
    minusArrow: require('../Assets/home/minusArrow.svg').default,
    tourIcon: require('../Assets/home/TourIcon.svg').default,
    questionCircle: require('../Assets/QuestionCircle.svg').default,
  },
  sidebarIcons: {
    Home: require('../Assets/sidebarIcons/home.svg').default,
    Compare: require('../Assets/sidebarIcons/compare.svg').default,
    Rate: require('../Assets/sidebarIcons/rate.svg').default,
    AllPriorities: require('../Assets/sidebarIcons/AllPriorities.svg').default,
    PriorityBatches: require('../Assets/sidebarIcons/priorityBatches.svg')
      .default,
    Goal: require('../Assets/sidebarIcons/goal.svg').default,
    scenarioPlanning: require('../Assets/sidebarIcons/scenarioPlanning.svg')
      .default,
    GoalBlue: require('../Assets/sidebarIcons/goal-blue-icon.svg').default,
    ImportIcon: require('../Assets/sidebarIcons/importIcon.svg').default,
    AdminIcon: require('../Assets/sidebarIcons/admin.svg').default,
    HelpIcon: require('../Assets/sidebarIcons/help.svg').default,
  },
  ideaIcons: {
    SortIcon: require('../Assets/Idea/sort-icon.svg').default,
    FilterIcon: require('../Assets/Idea/filter-icon.svg').default,
    EmptyData: require('../Assets/Idea/emptyData.svg').default,
    addIdeaModal: require('../Assets/Idea/addidea-modal.svg').default,
    addIdeaIcon: require('../Assets/Idea/addIdeaIcon.svg').default,
    addIdeaIconWhite: require('../Assets/Idea/addIdeaIcon-white.svg').default,
    PreviousIcon: require('../Assets/Idea/previous-icon.svg').default,
    ballonIcon: require('../Assets/Idea/ballon.png').default,
    BallonIcon: require('../Assets/Idea/ballon-icon.svg').default,
    GreenIcon: require('../Assets/Idea/green-icon.svg').default,
    YellowIcon: require('../Assets/Idea/yellow-icon.svg').default,
    RocketIcon: require('../Assets/Idea/rocketIcon.svg').default,
  },
  superAdminIcons: {
    DeleteIcon: require('../Assets/SuperAdmin/deleteUserIcon.svg').default,
  },
  compareIcons: {
    Compare: require('../Assets/compare/compareFinishIcon.svg').default,
    KudosIcon: require('../Assets/compare/kudosImage.svg').default,
    MileStoneIcon: require('../Assets/compare/mileStoneImage.svg').default,
  },
  ImportIcons: {
    UploadSuccess: require('../Assets/Import/uploadIcon.svg').default,
  },
  PriorityBatches: {
    createPriority: require('../Assets/priorityBatches/createPriority.svg')
      .default,
    comparePriority: require('../Assets/priorityBatches/comparePriority.svg')
      .default,
    deletePriorityBatch:
      require('../Assets/priorityBatches/deletePriorityBatch.svg').default,
    PriorityBatchOrange: require('../Assets/priorityBatches/priorityBatch.svg')
      .default,
    infoCircleIcon: require('../Assets/priorityBatches/InfoCircle.svg').default,
    warningIcon: require('../Assets/priorityBatches/warning.svg').default,
    minusButton: require('../Assets/priorityBatches/minusButton.svg').default,
  },
  notificationIcons: {
    IdeaNotificationIcon: require('../Assets/notification/ideaNotification.svg')
      .default,
    OpportunityNotificationIcon:
      require('../Assets/notification/opportunityNotification.svg').default,
    notificationIcon: require('../Assets/notification/notificationIcon.svg')
      .default,
  },
  icons: {
    DisableIcon: require('../Assets/Icons/disableIcon.svg').default,
    AddUser: require('../Assets/Icons/addUser.svg').default,
    AddUserWhite: require('../Assets/Icons/addUserWhite.svg').default,
    MicrosoftIcon: require('../Assets/Icons/Microsoft.svg').default,
    BackArrow: require('../Assets/Icons/backArrow.svg').default,
    NextArrow: require('../Assets/Icons/nextArrow.svg').default,
    ArchivedIcon: require('../Assets/Icons/archive.svg').default,
    helpIcon: require('../Assets/Icons/help-icon.svg').default,
  },
  admin: {
    remindLogo: require('../Assets/admin/remindLogo.svg').default,
    visionLogo: require('../Assets/admin/Vision.svg').default,
    stageIcon: require('../Assets/admin/Stage.svg').default,
    deleteIcon: require('../Assets/admin/DeleteIcon.svg').default,
    eyeIcon: require('../Assets/admin/EyeIcon.svg').default,
    disabledDeleteIcon: require('../Assets/admin/DisabledDelteIcon.svg')
      .default,
    deleteModalIcon: require('../Assets/admin/DeleteModalIcon.svg').default,
    multiLineIcon: require('../Assets/admin/MultiLineIcon.svg').default,
    singleLineIcon: require('../Assets/admin/SingleLine.svg').default,
    dropDownIcon: require('../Assets/admin/DropDownIcon.svg').default,
    linkIcon: require('../Assets/admin/LinkIcon.svg').default,
    calenderIcon: require('../Assets/admin/CalenderIcon.svg').default,
    publishIcon: require('../Assets/admin/PublishIcon.svg').default,
    confirmationIcon: require('../Assets/admin/ConfirmationIcon.svg').default,
    infoIcon: require('../Assets/admin/InfoIcon.svg').default,
    questioncircle: require('../Assets/admin/question-circle.svg').default,
    editIcon: require('../Assets/admin/EditIcon.svg').default,
    integrationIcon: require('../Assets/admin/integrationIcon.svg').default,
    zapierIcon: require('../Assets/admin/zappierIcon.svg').default,
    blurImageIcon: require('../Assets/admin/blurImage.png').default,
    filterPlaceholder: require('../Assets/admin/Scenario-place-holder.svg')
      .default,
    measurementFieldIcon: require('../Assets/admin/measurement.svg').default,
    mondayIcon: require('../Assets/admin/MondayIcon.svg').default,
    smartsheetIcon: require('../Assets/admin/SmartsheetIcon.svg').default,
    microsoftIcon: require('../Assets/admin/MicrosoftIcon.svg').default,
  },
  integration: {
    step1Icon: require('../Assets/Integration/step1.svg').default,
    step2Icon: require('../Assets/Integration/image.jpg').default,
    step3Icon: require('../Assets/Integration/image.jpg').default,
    step4Icon: require('../Assets/Integration/step4.svg').default,
    step5Icon: require('../Assets/Integration/step5.svg').default,
    step6Icon: require('../Assets/Integration/step6.svg').default,
    step7Icon: require('../Assets/Integration/step7.svg').default,
  },
  MeasurementIcon: {
    dollarIcon: require('../Assets/Measurement/Dollar.svg').default,
    scaleIcon: require('../Assets/Measurement/Scale.svg').default,
    hashIcon: require('../Assets/Measurement/Hash.svg').default,
  },
  smeProfile: {
    smeProfile: require('../Assets/SMEProfile/smeProfile.svg').default,
  },
};

